import { useEffect, useState } from "react";

const useDebounce = (props) => {
  const [debounceSearch, setDebounceSearch] = useState("");
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounceSearch(props);
    }, 500);

    return () => clearTimeout(timer);
  }, [props]);

  return { debounceSearch };
};

export default useDebounce;
